<h2 mat-dialog-title i18n="@@changePassword-changePassword" class="change-pwd-header">Change Password</h2>

<mat-dialog-content>
	<form>
		<mat-form-field appearance="outline" class="full-width-input" style="padding-bottom: 5px" subscriptSizing="dynamic">
			<mat-label i18n="@@changePassword-oldPassword">Old Password</mat-label>
			<input
				type="password"
				matInput
				[formControl]="oldPasswordFormControl"
				data-automation-id="old-password-input"
				autocomplete="off"
				required
			/>
			@if (passwordFormControl.hasError('password') && !passwordFormControl.hasError('required')) {
				<mat-error i18n="@@changePassword-enterOldPassword" data-automation-id="old-password-enter-error">
					Please enter your old password
				</mat-error>
			}
			@if (passwordFormControl.hasError('required')) {
				<mat-error i18n="@@changePassword-oldPasswordRequired" data-automation-id="old-password-enter-error">
					Your old password is <strong>required</strong> to change your password
				</mat-error>
			}
		</mat-form-field>

		<mat-form-field appearance="outline" class="full-width-input" style="padding-bottom: 5px" subscriptSizing="dynamic">
			<mat-label i18n="@@changePassword-newPassword">New Password</mat-label>
			<input
				type="password"
				matInput
				[formControl]="passwordFormControl"
				data-automation-id="new-password-input"
				autocomplete="new-password"
				required
			/>
			@if (passwordFormControl.hasError('password') && !passwordFormControl.hasError('required')) {
				<mat-error i18n="@@changePassword-pleaseEnterNewPassword" data-automation-id="new-password-enter-error">
					Please enter a new password
				</mat-error>
			}
			@if (passwordFormControl.hasError('required')) {
				<mat-error i18n="@@changePassword-passwordRequired" data-automation-id="new-password-enter-error">
					Password is <strong>required</strong>
				</mat-error>
			}
		</mat-form-field>

		<mat-form-field appearance="outline" class="full-width-input" style="padding-bottom: 5px" subscriptSizing="dynamic">
			<mat-label i18n="@@changePassword-confirmNewPassword">Confirm New Password</mat-label>
			<input
				type="password"
				matInput
				[formControl]="confirmPasswordFormControl"
				required
				autocomplete="new-password"
				data-automation-id="confirm-new-password-input"
			/>
			@if (confirmPasswordFormControl.hasError('password') && !confirmPasswordFormControl.hasError('required')) {
				<mat-error i18n="@@changePassword-pleaseConfirmNew" data-automation-id="confirm-new-password-enter-error">
					Please confirm your new password
				</mat-error>
			}
			@if (passwordFormControl.hasError('required')) {
				<mat-error i18n="@@changePassword-confirPasswordRequired" data-automation-id="confirm-new-password-enter-error">
					Password is <strong>required</strong>
				</mat-error>
			}
		</mat-form-field>

		<app-password-validation
			#passwordValidation
			[passwordFormControl]="passwordFormControl"
			[confirmPasswordFormControl]="confirmPasswordFormControl"
		>
		</app-password-validation>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="center">
	<button
		mat-button
		mat-dialog-close
		class="secondary-button"
		i18n="@@changePassword-cancel"
		data-automation-id="change-password-cancel-button"
	>
		Cancel
	</button>
	<button
		mat-button
		[disabled]="!passwordValidation.passwordIsValid()"
		(click)="submitChangePassword()"
		class="primary-button"
		changePassword-ChangePasswordButton
		data-automation-id="change-password-button"
	>
		Change Password
	</button>
</mat-dialog-actions>
